goog.provide('el8.uiwidget.Dipdown');

goog.require('el8.model.base');
goog.require('el8.util.consts');
goog.require('el8.template.uiwidget.Dipdown');


/**
 * This uiwidget renders/manages something like a dialog which pops down
 * from another element on screen. It is meant to feel lighter weight than
 * opening a new dialog.
 *
 * It's used in the letters FTUE (see rawFaxNag.js)
 */
el8.uiwidget.Dipdown = function(spec) {

    spec = spec || {};

    /* Required */
    this._anchor = spec.anchor; // can be either a function or an $elt

    /* Other specs */
    this._width = spec.width || 200;
    this._height = spec.height || 500;
    this._zIndex = spec.zIndex || 2;
    this._offsets = spec.offsets || {};
    this._anchorOffsets = spec.anchorOffsets || {};
    this._isModal = (spec.isModal !== false); // defaults true

    this._containerClass = spec.containerClass || 'el8DipdownContainer';
    this._tailClass = spec.tailClass || 'el8DipdownTail';
    this._titleClass = spec.titleClass || 'el8DipdownTitle';

    this._contentFn = spec.contentFn || null;
    this._renderFn = spec.renderFn || null;
    this._title = spec.title || null;
    this._titleHeight = spec.titleHeight || 20;
    this._appendElt = spec.appendElt || $('body'); // if the dipdown should live on top of a dialog or other elt

    this._pointUp = (spec.pointUp !== false); // defaults true

    /** Hold state **/
    this._isShowing = false;
};

el8.uiwidget.Dipdown.addEvents();

/**
 * IMPORTANT NOTE:
 *   Any time th Dipdown's show() method is part of the callback to a "click" event,
 *   the call needs to be followed with a "return false" or "e.stopPropagation" so that
 *   the click event isn't heard here, and the Dipdown promptly closed as a result.
 */
el8.uiwidget.Dipdown.prototype.show = function() {

    if (this._isShowing ) { return; }
    this._isShowing = true;

    this._container = $(el8.template.uiwidget.Dipdown.container({
        containerClass: this._containerClass,
        titleClass: this._titleClass,
        hasTitle: !!this._title
    })).hide();
    this._appendElt.append(this._container);

    this._tails = $(el8.template.uiwidget.Dipdown.tail({
        tailClass: this._tailClass
    }));

    if (this._title) {
        this._titleElt = $('.dropdown-title', this._container);
        this._titleElt.html(this._title instanceof Function ? this._title() : this._title);
    }
    this._contentElt = $('.dropdown-content', this._container);

    this._container.before(this._tails);
    this._container.show();

    this.renderContent();
    this._bindTriggers();
    this._adjustSizeAndPosition();

    var that = this;

    this._resizeFn =
        _.debounce(function(e) { that._adjustSizeAndPosition(); }, el8.util.consts.RESIZE_RATE);

    $(window).on('resize', this._resizeFn);

    if (this._isModal) {
        this._modalFn = function(e) {
            if (!$(e.target).closest('.dropdown-container').length) {
                that.hide();
            }
        };
        this.bindModalFn();
    }
};

el8.uiwidget.Dipdown.prototype.hide = function() {
    /* Check for null/undefined because hide() can get called
     * before show() */
    if (this._container) {
        this._container.remove();
        this._tails.remove();
    }
    this._isShowing = false;
    if (this._resizeFn) { $(window).unbind('resize', this._resizeFn); }
    if (this._isModal) { this.unbindModalFn(); }
};

el8.uiwidget.Dipdown.prototype.bindModalFn = function() {
    if (this._isModal) { $(document).on('click', this._modalFn); }
};

el8.uiwidget.Dipdown.prototype.unbindModalFn = function() {
    if (this._isModal) { $(document).unbind('click', this._modalFn); }
};

el8.uiwidget.Dipdown.prototype.renderContent  = function() {
    if (this._contentFn) {
        this.setContent(this._contentFn());
    }

    if (this._renderFn) { this._renderFn(); }
};

el8.uiwidget.Dipdown.prototype.toggle = function() {
    if (this._isShowing) {
        this.hide();
    } else {
        this.show();
    }
};
el8.uiwidget.Dipdown.prototype.isShowing = function() {
    return this._isShowing;
};

el8.uiwidget.Dipdown.prototype.setContent = function($contents) {
    this.getContentElt().html($contents);
};

el8.uiwidget.Dipdown.prototype.setAnchor = function($elt) {
    this._anchor = $elt;
};

el8.uiwidget.Dipdown.prototype._adjustSizeAndPosition = function() {

    var tailHeight = 10;
    var $anchor = $.isFunction(this._anchor) ? this._anchor() : this._anchor;
    var anchorLeft = $anchor.offset()['left']; // we may change offsetLeft but we'll still need the orig value
    var offsetTop = $anchor.offset()['top'] + (this._offsets['top'] || 0)
        - this._appendElt.offset()['top'] - (this._pointUp ? 0 : tailHeight);
    var offsetLeft = anchorLeft + (this._offsets['left'] || 0) - this._appendElt.offset()['left'];
    var width = $.isFunction(this._width) ? this._width() : this._width;

    /* We use $(document).width() and $(document).height() below rather than
     * $(window) because, while in the main Elation app, $(document) and $(window)
     * have the same width and height, in other contexts (e.g. passport), the two
     * may not, i.e. when the app isn't fixed within the window
     */

    /* Do not compromise on width; adjust offset instead */
    if (width > ($(document).width() - 15 - offsetLeft)) {
        offsetLeft = $(document).width() - width - 15;
    }

    var height = Math.min($(document).height() - offsetTop - 50,
        $.isFunction(this._height) ? this._height() : this._height);

    this._container.outerWidth(width);
    this._container.outerHeight(height);
    var zIndex = ($.isFunction(this._zIndex)) ? this._zIndex() : this._zIndex;

    this._container.css({
        'z-index': zIndex,
        'top': offsetTop,
        'left': offsetLeft
    });

    $('.dropdown-tail-body', this._tails).css({
        'z-index': zIndex+1,
        // body needs to 1x1 offset from border
        'top': offsetTop - 10 + 1 + (this._pointUp ? 0 : (height + tailHeight)),
        'left': anchorLeft + 20 + 1 - this._appendElt.offset()['left'] + (this._anchorOffsets['left'] || 0)
    });
    $('.dropdown-tail-border', this._tails).css({
        'z-index': zIndex,
        'top': offsetTop - 10 + (this._pointUp ? 0 : (height + tailHeight)),
        'left': anchorLeft + 20 - this._appendElt.offset()['left'] + (this._anchorOffsets['left'] || 0)
    });

    if (this._titleElt) {
        this._titleElt.height(this._titleHeight);
        this._contentElt.height(height - this._titleElt.outerHeight(true));
    } else {
        this._contentElt.height(height);
    }

    this.trigger('el8_adjustSize');
};

el8.uiwidget.Dipdown.prototype._bindTriggers = function() {
    var that = this;
    this._container.on('click', '.dropdown-close-trigger',  function() {
        that.hide();
    });
};

el8.uiwidget.Dipdown.prototype.getContentElt = function() {
    return this._contentElt;
};

el8.uiwidget.Dipdown.prototype.getContainer = function() {
    return this._container;
};
